import React, { useState, useEffect } from 'react';

const MiPerfil = () => {
  const [rutSeguro, setRutSeguro] = useState('');
  const [nombreFuncionario, setNombreFuncionario] = useState('');
  const [mes, setMes] = useState('TODO_EL_AÑO');
  const [loading, setLoading] = useState(false);
  const [asistenciaData, setAsistenciaData] = useState(null);

  // 1. Estados para el Formulario de Datos Personales
  const [loadingPerfil, setLoadingPerfil] = useState(false);
  const [perfilForm, setPerfilForm] = useState({
    fechaNacimiento: '', nacionalidad: '', direccion: '', comuna: '',
    estadoCivil: '', telefono: '', correoPersonal: '', contactoEmergencia: '',
    parentesco: '', contacto: '', cargo: ''
  });

  // Endpoints eCredenciales
  const scriptUrlAsistencia = "https://script.google.com/macros/s/AKfycbwja5MNYC0RZBwzPsm9geJJ_GyOzExaH6HnQVu5tTbVdtQbr2C-50tWHn1dOI5Wm1_3/exec";
  const tokenGAsistencia = "Asistencia2024*";

  // URL de la planilla de perfiles
  const scriptUrlPerfil = "https://script.google.com/macros/s/AKfycbwihoqXZw77XT7yIFah4eTPH5RAul8Q-A-_bcYrz8GnpEM120fZ09X2m5bDfI0EtYvOBw/exec";
  const tokenGPerfil = "PerfilBetterland2024*";

  // Función interna para formatear la fecha a DD/MM/AAAA
  const formatearFecha = (fechaTexto) => {
    if (!fechaTexto) return '';
    
    if (fechaTexto.includes('/') || (fechaTexto.includes('-') && fechaTexto.length === 10 && !fechaTexto.includes('GMT'))) {
      return fechaTexto;
    }

    try {
      const fecha = new Date(fechaTexto);
      if (isNaN(fecha.getTime())) return fechaTexto;

      const dia = String(fecha.getDate()).padStart(2, '0');
      const mesNum = String(fecha.getMonth() + 1).padStart(2, '0');
      const anio = fecha.getFullYear();

      return `${dia}/${mesNum}/${anio}`;
    } catch (e) {
      return fechaTexto;
    }
  };

  // 1. Al cargar la página, obtenemos los datos de sesión del Backend
  useEffect(() => {
    const obtenerPerfil = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('https://asistencia-betterland.onrender.com/api/mi-perfil', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) throw new Error("Sesión inválida.");
        
        const data = await response.json();
        const rutRecibido = data.rut ? data.rut.trim() : '';
        setRutSeguro(rutRecibido); 
        
      } catch (error) {
        console.error("Error obteniendo perfil:", error);
        alert("Error al cargar el perfil. Por favor, inicia sesión de nuevo.");
      }
    };

    obtenerPerfil();
  }, []);

  // 2. Disparador automático: Consulta Asistencia
  useEffect(() => {
    if (rutSeguro) {
      consultarAsistencia(rutSeguro, mes);
    }
  }, [rutSeguro, mes]);

  // 3. Disparador: Carga de Datos Personales
  useEffect(() => {
    if (rutSeguro) {
      cargarDatosPersonales(rutSeguro);
    }
  }, [rutSeguro]);

  // 4. Función de Asistencia Modificada
  const consultarAsistencia = async (rutParaConsultar, mesSeleccionado) => {
    setLoading(true);
    const urlBusqueda = `${scriptUrlAsistencia}?rut=${encodeURIComponent(rutParaConsultar)}&token=${tokenGAsistencia}&mes=${mesSeleccionado}`;

    try {
      const response = await fetch(urlBusqueda, { redirect: 'follow' });
      const data = await response.json();

      if (data.error) {
        console.error("Error del script:", data.error);
        setAsistenciaData(null);
        return;
      }

      if (data.nombre) {
        setNombreFuncionario(data.nombre);
        
        setAsistenciaData({
          nombre: data.nombre,
          atrasos: data.atrasoTotalMinutos,
          ausencias: data.diasAusentes,
          licencias: data.licenciasMedicas || 0,
          admin: data.adminRestantes || '0 días, 0 hrs, 0 min'
        });
      } else {
        setAsistenciaData(null);
      }
    } catch (e) {
      console.error("Error de conexión con Sheets:", e);
    } finally {
      setLoading(false);
    }
  };

  const cargarDatosPersonales = async (rutConPuntos) => {
    setLoadingPerfil(true);
    const rutParaPerfil = rutConPuntos.replace(/\./g, '').trim(); 

    try {
      const response = await fetch(scriptUrlPerfil, {
        method: 'POST',
        redirect: 'follow',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8', 
        },
        body: JSON.stringify({
          action: 'buscarPerfil',
          rut: rutParaPerfil,
          token: tokenGPerfil
        })
      });
      
      const resData = await response.json();

      if (resData.success) {
        setPerfilForm({
          ...resData.data,
          fechaNacimiento: formatearFecha(resData.data.fechaNacimiento)
        });
      } else {
        console.error("Aviso Planilla Perfil:", resData.error);
        alert("Aviso Perfil: " + resData.error);
      }
    } catch (error) {
      console.error("Error conectando a Planilla de Perfiles:", error);
      alert("Error de red al cargar datos personales. Revisa la consola.");
    } finally {
      setLoadingPerfil(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPerfilForm(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const guardarDatosPersonales = async (e) => {
    e.preventDefault();
    setLoadingPerfil(true);
    const rutParaPerfil = rutSeguro.replace(/\./g, '').trim();

    try {
      const response = await fetch(scriptUrlPerfil, {
        method: 'POST',
        redirect: 'follow',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        },
        body: JSON.stringify({
          action: 'guardarPerfil',
          rut: rutParaPerfil,
          token: tokenGPerfil,
          perfil: perfilForm
        })
      });
      const resData = await response.json();

      if (resData.success) {
        alert("¡Tus datos personales fueron actualizados en la planilla con éxito!");
      } else {
        alert("Error de guardado: " + resData.error);
      }
    } catch (error) {
      console.error("Error al guardar perfil:", error);
      alert("Error de conexión al intentar guardar.");
    } finally {
      setLoadingPerfil(false);
    }
  };

  return (
    <div style={{ maxWidth: '700px', margin: '30px auto', padding: '20px', fontFamily: 'sans-serif' }}>
      
      {/* Cabecera Dinámica */}
      <div style={{ background: '#2c3e50', color: '#ffffff', padding: '25px', borderRadius: '12px', marginBottom: '25px', boxShadow: '0 4px 10px rgba(177, 172, 172, 0.78)' }}>
        <h2 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px', color: '#ffffff' }}>
          👤 {nombreFuncionario || 'Cargando Funcionario...'}
        </h2>
        <p style={{ margin: '8px 0 0', opacity: 0.9, fontSize: '0.9em', fontWeight: '500', color: '#ffffff' }}>
          RUT: {rutSeguro || 'Buscando identidad...'}
        </p>
      </div>

      {/* Módulo de Asistencia */}
      <div style={{ background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', border: '1px solid #eee', marginBottom: '30px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <h3 style={{ marginTop: 0, marginBottom: 0, color: '#333' }}>📊 Resumen de Asistencia</h3>
          {loading && <span style={{ fontSize: '0.85em', color: '#0073aa', fontWeight: 'bold' }}>🔄 Actualizando...</span>}
        </div>

        {/* BANNER DESTACADO */}
        <div style={{
          background: '#eef6fc',
          borderLeft: '4px solid #3182ce',
          padding: '12px 15px',
          borderRadius: '8px',
          marginBottom: '20px',
          fontSize: '0.85em',
          color: '#2b6cb0',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <span style={{ fontSize: '1.3em' }}>ℹ️</span>
          <div>
            <strong>Aviso de sincronización:</strong> Los datos de asistencia y días administrativos se actualizan de forma semanal. Es posible que la información mostrada presente un desfase de hasta 7 días respecto al registro diario.
          </div>
        </div>

        <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end', marginTop: '15px' }}>
          <div style={{ flexGrow: 1 }}>
            <label style={{ display: 'block', fontSize: '0.8em', color: '#666', marginBottom: '4px' }}>Seleccionar Período</label>
            <select 
              value={mes} 
              onChange={(e) => setMes(e.target.value)} 
              disabled={loading}
              style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', background: loading ? '#f5f5f5' : '#fff' }}
            >
              <option value="TODO_EL_AÑO">📅 Todo el Año</option>
              <option value="01">Enero</option><option value="02">Febrero</option><option value="03">Marzo</option>
              <option value="04">Abril</option><option value="05">Mayo</option><option value="06">Junio</option>
              <option value="07">Julio</option><option value="08">Agosto</option><option value="09">Septiembre</option>
              <option value="10">Octubre</option><option value="11">Noviembre</option><option value="12">Diciembre</option>
            </select>
          </div>
        </div>

        {asistenciaData ? (
          <div style={{ marginTop: '25px', paddingTop: '20px', borderTop: '1px dashed #ddd' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div style={{ padding: '15px', borderRadius: '10px', textAlign: 'center', background: '#fff5f5', color: '#c53030' }}>
                <span>⏰</span>
                <small style={{ display: 'block', fontWeight: 'bold', fontSize: '0.7em', marginTop: '5px' }}>ATRASOS / RETIROS</small>
                <p style={{ margin: '5px 0 0', fontSize: '1.3em' }}><strong>{asistenciaData.atrasos}</strong> min</p>
              </div>
              
              <div style={{ padding: '15px', borderRadius: '10px', textAlign: 'center', background: '#ebf8ff', color: '#2b6cb0' }}>
                <span>🚫</span>
                <small style={{ display: 'block', fontWeight: 'bold', fontSize: '0.7em', marginTop: '5px' }}>AUSENCIAS</small>
                <p style={{ margin: '5px 0 0', fontSize: '1.3em' }}><strong>{asistenciaData.ausencias}</strong> días</p>
              </div>

              {/* TARJETA VERDE: Días Admin + Nota Aclaratoria */}
              <div style={{ padding: '15px', borderRadius: '10px', textAlign: 'center', background: '#f0fff4', color: '#2f855a', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <span>⭐</span>
                  <small style={{ display: 'block', fontWeight: 'bold', fontSize: '0.7em', marginTop: '5px' }}>DÍAS ADMIN. DISPONIBLES</small>
                  <p style={{ margin: '5px 0 0', fontSize: '1.05em', fontWeight: 'bold', wordBreak: 'break-word' }}>
                    {asistenciaData.admin}
                  </p>
                </div>
                <span style={{ display: 'block', fontSize: '0.72em', marginTop: '10px', color: '#276749', fontStyle: 'italic', lineHeight: '1.2' }}>
                  *No incluye días de vacaciones. Gestionar directamente en Administración.
                </span>
              </div>

              {/* TARJETA AMARILLA: Licencias + Nota Aclaratoria */}
              <div style={{ padding: '15px', borderRadius: '10px', textAlign: 'center', background: '#fffaf0', color: '#c05621', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <span>🏥</span>
                  <small style={{ display: 'block', fontWeight: 'bold', fontSize: '0.7em', marginTop: '5px' }}>LICENCIAS</small>
                  <p style={{ margin: '5px 0 0', fontSize: '1.3em' }}><strong>{asistenciaData.licencias}</strong> días</p>
                </div>
                <span style={{ display: 'block', fontSize: '0.72em', marginTop: '10px', color: '#9c4221', fontStyle: 'italic', lineHeight: '1.2' }}>
                  *Si usas un día administrativo para cubrir una licencia, aunque la licencia médica sea tramitada, al ser cubierta con un día administrativo no se verá reflejada en el sistema interno, ya que el día se justifica bajo la modalidad de permiso.
                </span>
              </div>

            </div>
          </div>
        ) : (
          !loading && (
            <div style={{ marginTop: '25px', textAlign: 'center', padding: '20px', background: '#f9f9f9', borderRadius: '8px', color: '#777' }}>
              🔍 No se registran datos de asistencia para el período seleccionado.
            </div>
          )
        )}
      </div>

      {/* Formulario de Modificación de Datos Personales */}
      <div style={{ background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', border: '1px solid #eee' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ marginTop: 0, marginBottom: 0, color: '#333' }}>📝 Mis Datos Personales</h3>
          {loadingPerfil && <span style={{ fontSize: '0.85em', color: '#e67e22', fontWeight: 'bold' }}>🔄 Sincronizando...</span>}
        </div>

        <form onSubmit={guardarDatosPersonales}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            
            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Fecha de Nacimiento</label>
              <input type="text" name="fechaNacimiento" value={perfilForm.fechaNacimiento} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Nacionalidad</label>
              <input type="text" name="nacionalidad" value={perfilForm.nacionalidad} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div style={{ gridColumn: 'span 2' }}>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Dirección</label>
              <input type="text" name="direccion" value={perfilForm.direccion} onChange={handleInputChange} style={{ width: '96%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Comuna</label>
              <input type="text" name="comuna" value={perfilForm.comuna} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Estado Civil</label>
              <input type="text" name="estadoCivil" value={perfilForm.estadoCivil} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Teléfono de Contacto</label>
              <input type="text" name="telefono" value={perfilForm.telefono} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Correo Personal</label>
              <input type="email" name="correoPersonal" value={perfilForm.correoPersonal} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Contacto Emergencia</label>
              <input type="text" name="contactoEmergencia" value={perfilForm.contactoEmergencia} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Parentesco</label>
              <input type="text" name="parentesco" value={perfilForm.parentesco} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Número de Contacto</label>
              <input type="text" name="contacto" value={perfilForm.contacto} onChange={handleInputChange} style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85em', color: '#555', marginBottom: '5px' }}>Cargo Actual</label>
              <input type="text" name="cargo" value={perfilForm.cargo} disabled style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
            </div>

          </div>

          <button 
            type="submit" 
            disabled={loadingPerfil}
            style={{ width: '100%', marginTop: '25px', padding: '12px', background: '#27ae60', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '1em', fontWeight: 'bold', cursor: loadingPerfil ? 'not-allowed' : 'pointer', transition: 'background 0.2s' }}
          >
            {loadingPerfil ? '💾 Guardando cambios...' : '💾 Actualizar Mis Datos'}
          </button>
        </form>
      </div>

    </div>
  );
};

export default MiPerfil;